var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6.74805H14.75V5.24805H17V2.24805H2V5.24805H4.625V6.74805H0.5V0.748047H18.5V6.74805Z",
    fill: "#150F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 18.748H4.25V2.99805H14.75V18.748ZM5.75 17.248H13.25V4.49805H5.75V17.248Z",
    fill: "#150F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 7.49805H6.875V8.99805H12.125V7.49805Z",
    fill: "#150F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.498H6.5V11.998H12.5V10.498Z",
    fill: "#150F2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 13.498H6.875V14.998H12.125V13.498Z",
    fill: "#150F2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.99805H2.75V4.49805H16.25V2.99805Z",
    fill: "#150F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/payout.d0c2c7fa.svg";
export { ForwardRef as ReactComponent };